import React, { useEffect, useState } from "react";
import { Image, Text, TouchableOpacity, View } from "react-native";
import { AppColors } from "../../utility/AppColors";
import { AppFontStyle } from "../../styles/AppFontStyle";
import { StackActions, useNavigation } from "@react-navigation/native";
import {
  CreateResponsiveStyle,
  DEVICE_SIZES,
  useDeviceSize,
} from "rn-responsive-styles";
import Separator from "../Separator";
import { AppImages } from "../../utility/AppImages";
import { CommonButton } from "../../common/CommonButton";
import { AppScreens } from "../../screens/Utility/AppScreens";
import CommonTextInputWeb from "../../common/CommonTextInputWeb";

import { toast } from "react-toastify";
import BeltRanking from "./BeltRanking";
import { allRankingAPI } from "../../services/eventsAPI";
import RankingTableSkeleton from "../skeleton-components/RankingTableSkeleton";

interface RankingData {
  // Define structure based on your API response
  [key: string]: any;
}

interface UserData {
  // Define structure based on your user data
  [key: string]: any;
}

interface RankingTableProps {
  filteredRankingData?: RankingData[];
  showLoader?: boolean;
  handleSearchInput: (text: string) => void;
  searchEvent: string;
  userData?: UserData;
  isLoading?: boolean;
  setActiveTab?: any;
  scrollViewRef?: any;
}

const RankingTable: React.FC<RankingTableProps> = ({
  filteredRankingData,
  showLoader,
  handleSearchInput,
  searchEvent,
  userData,
  isLoading = false,
  setActiveTab,
  scrollViewRef,
}) => {
  const deviceSize = useDeviceSize();
  const styles = useStyles();
  const navigation = useNavigation();

  if (isLoading) {
    return <RankingTableSkeleton />;
  }

  return (
    <View style={{}}>
      <View
        style={{
          width: "100%",
          flexDirection: "row",
          alignItems: "center",
          gap: 10,
        }}
      >
        <CommonTextInputWeb
          placeholder="Enter/select game name to filter rankings"
          mainStyle={[styles.searchTextStyle]}
          inputStyle={[
            AppFontStyle.MEDIUM_ANYBODY_14,
            {
              marginVertical: 0,
              marginHorizontal: 0,
              padding: 10,
              color: AppColors.white,
              width: 344,
              height: 38,
              lineHeight: 18,
            },
          ]}
          prefixIconVisibility={false}
          onChangeText={handleSearchInput}
          isPassword={false}
          value={searchEvent}
          onSubmitEditing={() => {}}
          autoCapitalize="none"
        />
      </View>
      <View
        style={[
          {
            marginTop: 10,
            justifyContent: "space-between",
            gap: 10,
          },
          styles.deviceflexDirection,
        ]}
      >
        {filteredRankingData && (
          <BeltRanking
            styles={styles}
            showLoader={showLoader}
            rankingData={filteredRankingData}
            setActiveTab={setActiveTab}
            scrollViewRef={scrollViewRef}
          />
        )}
      </View>
    </View>
  );
};

export default RankingTable;

const useStyles = CreateResponsiveStyle(
  {
    searchTextStyle: {
      backgroundColor: AppColors.gray_1F2937,
      borderWidth: 0.8,
      borderColor: AppColors.gray_374151,
      borderRadius: 6,
      verticalAlign: "top",
      alignItems: "center",
      gap: 6,
    },
    serachBtn: {
      width: 20,
      height: 20,
    },
    deviceflexDirection: {
      flexDirection: "row",
    },
    beltsRankingView: {
      width: "100%",
      borderRadius: 10,
      paddingBottom: 15,
      gap: 10,
    },
  },
  {
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.SM]: {
      deviceflexDirection: {
        flexDirection: "column",
      },
    },
    [DEVICE_SIZES.XS]: {
      deviceflexDirection: {
        flexDirection: "column",
      },
    },
  }
);
